import { IconSearch } from '@developerz/ui';
import { For, type JSX } from 'solid-js';
import { t } from '../i18n';
import type { PolicyStatus } from './PolicyStatusBadge';
import { Button } from './ui/Button';

// Repos toolbar (spec §5 filter row): name search with a leading icon, policy
// filter buttons, and a name-sort toggle. Fully controlled — the Repos container
// owns the state and does the filtering.

const STATUSES: readonly PolicyStatus[] = ['valid', 'invalid', 'missing', 'unknown'];

export type RepoFiltersProps = {
  readonly query: string;
  readonly onQuery: (value: string) => void;
  readonly active: ReadonlySet<PolicyStatus>;
  readonly onToggle: (status: PolicyStatus) => void;
  /** Current sort direction — the button label shows what's applied. */
  readonly asc: boolean;
  readonly onSort: () => void;
};

export function RepoFilters(props: RepoFiltersProps): JSX.Element {
  return (
    <div class="filter-row repos__filters">
      <div class="search-input">
        <IconSearch size="1rem" />
        <input
          type="search"
          class="input"
          placeholder={t('repos.filter_placeholder')}
          aria-label={t('repos.filter_aria')}
          value={props.query}
          onInput={(e) => props.onQuery(e.currentTarget.value)}
        />
      </div>

      <For each={STATUSES}>
        {(status) => (
          <Button
            variant="outline"
            aria-pressed={props.active.has(status) ? 'true' : 'false'}
            onClick={() => props.onToggle(status)}
          >
            {t(`repos.policy_${status}`)}
          </Button>
        )}
      </For>

      <Button variant="outline" onClick={() => props.onSort()}>
        {props.asc ? t('repos.sort_asc') : t('repos.sort_desc')}
      </Button>
    </div>
  );
}
